/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { slackDirectoryConnectionsBegin } from "../funcs/slackDirectoryConnectionsBegin.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { BeginResponseBody } from "../models/components/beginresponsebody.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  BeginSlackDirectoryConnectionRequest,
  BeginSlackDirectoryConnectionSecurity,
} from "../models/operations/beginslackdirectoryconnection.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type BeginSlackDirectoryConnectionMutationVariables = {
  request: BeginSlackDirectoryConnectionRequest;
  security?: BeginSlackDirectoryConnectionSecurity | undefined;
  options?: RequestOptions;
};

export type BeginSlackDirectoryConnectionMutationData = BeginResponseBody;

export type BeginSlackDirectoryConnectionMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * begin slackDirectoryConnections
 */
export function useBeginSlackDirectoryConnectionMutation(
  options?: MutationHookOptions<
    BeginSlackDirectoryConnectionMutationData,
    BeginSlackDirectoryConnectionMutationError,
    BeginSlackDirectoryConnectionMutationVariables
  >,
): UseMutationResult<
  BeginSlackDirectoryConnectionMutationData,
  BeginSlackDirectoryConnectionMutationError,
  BeginSlackDirectoryConnectionMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildBeginSlackDirectoryConnectionMutation(client, options),
    ...options,
  });
}

export function mutationKeyBeginSlackDirectoryConnection(): MutationKey {
  return ["@gram/client", "slackDirectoryConnections", "begin"];
}

export function buildBeginSlackDirectoryConnectionMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: BeginSlackDirectoryConnectionMutationVariables,
  ) => Promise<BeginSlackDirectoryConnectionMutationData>;
} {
  return {
    mutationKey: mutationKeyBeginSlackDirectoryConnection(),
    mutationFn: function beginSlackDirectoryConnectionMutationFn({
      request,
      security,
      options,
    }): Promise<BeginSlackDirectoryConnectionMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(slackDirectoryConnectionsBegin(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
